import { call, put, takeEvery } from 'redux-saga/effects';
import {
    ADMIN_LOGIN_REQUEST,
    ADMIN_LOGIN_SUCCESS,
    ADMIN_LOGIN_FAILURE,
    VERIFY_MFA_REQUEST,
    VERIFY_MFA_SUCCESS,
    VERIFY_MFA_FAILURE,
    RESET_MFA_REQUEST,
    RESET_MFA_SUCCESS,
    RESET_MFA_FAILURE,
    RESET_MFA_TOKEN_REQUEST,
    RESET_MFA_TOKEN_SUCCESS,
    RESET_MFA_TOKEN_FAILURE,
    SECURE_QR_REQUEST,
    SECURE_QR_SUCCESS,
    SECURE_QR_FAILURE,
    ADMIN_RESET_PASSWORD_REQUEST,
    ADMIN_RESET_PASSWORD_SUCCESS,
    ADMIN_RESET_PASSWORD_FAILURE,
} from '../actions/adminAuthActions';
import {
    adminLogin,
    adminVerifyMfa,
    adminResetMfa,
    resetMfaToken,
    getSecureQR,
    adminResetPassword,
} from '../../services/api';

function* adminLoginSaga(action) {
    try {
        const { email, password } = action.payload;
        const response = yield call(adminLogin, email, password);
        yield put({ type: ADMIN_LOGIN_SUCCESS, payload: response });
    } catch (error) {
        let errorData;
        try {
            errorData = JSON.parse(error.message);
        } catch {
            errorData = {
                detail: error.response?.data?.detail || error.message || 'Erreur de connexion',
                error_code: error.response?.data?.error_code || 'UNKNOWN_ERROR',
            };
        }
        yield put({ type: ADMIN_LOGIN_FAILURE, payload: errorData });
    }
}

function* verifyMfaSaga(action) {
    try {
        const { mfa_code, session_id } = action.payload;
        const response = yield call(adminVerifyMfa, mfa_code, session_id);
        yield put({ type: VERIFY_MFA_SUCCESS, payload: response });
    } catch (error) {
        let errorData;
        try {
            errorData = JSON.parse(error.message);
        } catch {
            errorData = {
                detail: error.response?.data?.detail || error.message || 'Code MFA incorrect',
                error_code: error.response?.data?.error_code || 'UNKNOWN_ERROR',
            };
        }
        yield put({ type: VERIFY_MFA_FAILURE, payload: errorData });
    }
}

function* resetMfaSaga(action) {
    try {
        const { session_id } = action.payload;
        const response = yield call(adminResetMfa, session_id);
        yield put({ type: RESET_MFA_SUCCESS, payload: response });
    } catch (error) {
        let errorData;
        try {
            errorData = JSON.parse(error.message);
        } catch {
            errorData = {
                detail: error.response?.data?.detail || error.message || 'Erreur lors de la réinitialisation',
                error_code: error.response?.data?.error_code || 'UNKNOWN_ERROR',
            };
        }
        yield put({ type: RESET_MFA_FAILURE, payload: errorData });
    }
}

function* resetMfaTokenSaga(action) {
    try {
        const { email } = action.payload;
        const response = yield call(resetMfaToken, email);
        yield put({ type: RESET_MFA_TOKEN_SUCCESS, payload: response });
    } catch (error) {
        let errorData;
        try {
            errorData = JSON.parse(error.message);
        } catch {
            errorData = {
                detail: error.response?.data?.detail || error.message || 'Erreur lors de la réinitialisation du token',
                error_code: error.response?.data?.error_code || 'UNKNOWN_ERROR',
            };
        }
        yield put({ type: RESET_MFA_TOKEN_FAILURE, payload: errorData });
    }
}

function* secureQRSaga(action) {
    try {
        const { token, email } = action.payload;
        const response = yield call(getSecureQR, token, email);
        yield put({ type: SECURE_QR_SUCCESS, payload: response });
    } catch (error) {
        let errorData;
        try {
            errorData = JSON.parse(error.message);
        } catch {
            errorData = {
                detail: error.response?.data?.detail || error.message || 'Erreur lors de la génération du QR',
                error_code: error.response?.data?.error_code || 'UNKNOWN_ERROR',
            };
        }
        yield put({ type: SECURE_QR_FAILURE, payload: errorData });
    }
}

function* adminResetPasswordSaga(action) {
    try {
        const { email } = action.payload;
        const response = yield call(adminResetPassword, email);
        yield put({ type: ADMIN_RESET_PASSWORD_SUCCESS, payload: response });
    } catch (error) {
        let errorData;
        try {
            errorData = JSON.parse(error.message);
        } catch {
            errorData = {
                detail: error.response?.data?.detail || error.message || 'Erreur lors de la réinitialisation',
                error_code: error.response?.data?.error_code || 'UNKNOWN_ERROR',
            };
        }
        yield put({ type: ADMIN_RESET_PASSWORD_FAILURE, payload: errorData });
    }
}

export function* watchAdminAuth() {
    yield takeEvery(ADMIN_LOGIN_REQUEST, adminLoginSaga);
    yield takeEvery(VERIFY_MFA_REQUEST, verifyMfaSaga);
    yield takeEvery(RESET_MFA_REQUEST, resetMfaSaga);
    yield takeEvery(RESET_MFA_TOKEN_REQUEST, resetMfaTokenSaga);
    yield takeEvery(SECURE_QR_REQUEST, secureQRSaga);
    yield takeEvery(ADMIN_RESET_PASSWORD_REQUEST, adminResetPasswordSaga);
}

